import { linkMarkName, tagNodeName } from '@/services/forms/tmTiptap/const'

export const createParagraphContent = (line: string) => `<p>${line}</p>`
export const createTagContent = (tag: string) =>
  `<span data-type="${tagNodeName}" data-tag="${tag}"><span>${tag}</span></span>`
export const createLinkSpanContent = (link: string) => `<span data-type="${linkMarkName}">${link}</span>`
export const createLinkAContent = (link: string) => `<a href="${link}" target="_blank">${link}</a>`
